import { Helpers } from '../../helpers';
import { IInitialFlowRateQi } from '../../interfaces/iinitial-flow-rate-qi';
import { ForecastHorizontal } from '../forecast-horizontal';

export class InitialFlowRateQiBase {
  InitialFlowRateQiId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ForecastHorizontal_InitialFlowRateQi?: Array<ForecastHorizontal> | null;

  constructor(item?: IInitialFlowRateQi) {
    if (item) {

      this.InitialFlowRateQiId = item.InitialFlowRateQiId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ForecastHorizontal_InitialFlowRateQi = Helpers.createClassArray(ForecastHorizontal, item.ForecastHorizontal_InitialFlowRateQi);
    }
  }
}